export interface GameCatalogItem {
  id: number;
  title: string;
  type: string;
  providerId: string;
  providerName: string;
  code: string;
  filters?: string[] | null;
  pageTitle?: string;
  imageUrl?: string;
  imgVer?: number;
  videoUrl?: string;
  minBet?: number;
  denyBonus?: boolean;
  variedImg?: boolean;
  status?: string;
  [key: string]: unknown;
}

const isOptionalString = (value: unknown) =>
  value === undefined || typeof value === 'string';

const isOptionalNumber = (value: unknown) =>
  value === undefined || typeof value === 'number';

const isOptionalBoolean = (value: unknown) =>
  value === undefined || typeof value === 'boolean';

export const isGameCatalogItem = (value: unknown): value is GameCatalogItem => {
  if (!value || typeof value !== 'object') return false;

  const game = value as Record<string, unknown>;
  const hasValidFilters =
    game.filters === undefined ||
    game.filters === null ||
    (Array.isArray(game.filters) &&
      game.filters.every((filter) => typeof filter === 'string'));

  return (
    typeof game.id === 'number' &&
    typeof game.title === 'string' &&
    typeof game.type === 'string' &&
    typeof game.providerId === 'string' &&
    typeof game.providerName === 'string' &&
    typeof game.code === 'string' &&
    hasValidFilters &&
    isOptionalString(game.pageTitle) &&
    isOptionalString(game.imageUrl) &&
    isOptionalNumber(game.imgVer) &&
    isOptionalString(game.videoUrl) &&
    isOptionalNumber(game.minBet) &&
    isOptionalBoolean(game.denyBonus) &&
    isOptionalBoolean(game.variedImg) &&
    isOptionalString(game.status)
  );
};

export const normalizeGameCatalogItems = (data: unknown): GameCatalogItem[] =>
  Array.isArray(data) ? data.filter(isGameCatalogItem) : [];
